import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import Checkbox from "@mui/material/Checkbox";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";

function SortableItem({ id, label, checked, onToggle }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    display: "flex",
    alignItems: "center",
    padding: "8px",
    border: "1px solid #ccc",
    borderRadius: "4px",
    marginBottom: "4px",
    background: "white",
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes}>
      {/* Drag handle: apply listeners only to this element */}
      <div {...listeners} style={{ cursor: "grab", marginRight: 8 }}>
        <DragIndicatorIcon fontSize="small" />
      </div>

      {/* The checkbox is outside of the draggable handle */}
      <Checkbox checked={checked} onChange={onToggle} disableRipple />

      <span>{label}</span>
    </div>
  );
}

export default SortableItem;
